const likeMarkerClass = "likeMarker";
const likeMarkerSetUpClass = `${likeMarkerClass}--setUp`;
const likeMarkerLikedClass = `${likeMarkerClass}--liked`;
const likeMarkerNonInteractiveClass = `${likeMarkerClass}--nonInteractive`;

export default function initLikeMarkerSupport() {
	const listener = (event: MouseEvent) => {
		let element = event.target as HTMLElement;
		let productId = element.getAttribute("data-productId");
		while (!productId && (element = element.parentElement) !== null) {
			productId = element.getAttribute("data-productId");
		}
		const baseHref = document.getElementsByTagName("base").item(0).href;
		const endpoint = `${baseHref}${baseHref.charAt(baseHref.length - 1) === '/' ? '' : '/'}likes/update.html?dressId=${productId}&action=${element.classList.contains(likeMarkerLikedClass) ? "remove" : "add"}`;

		const xhr = new XMLHttpRequest();
		xhr.open("GET", endpoint);
		xhr.setRequestHeader("Accept", "application/json");
		xhr.onreadystatechange = function() {
			if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
				element.classList.toggle(likeMarkerLikedClass);
			}
		};
		xhr.send();
	};

	const setUpLikeMarkers = () => {
		const likeMarkerNodes = document.querySelectorAll(`.${likeMarkerClass}:not(.${likeMarkerSetUpClass}):not(.${likeMarkerNonInteractiveClass})`);
		for (let i = 0; i < likeMarkerNodes.length; i++) {
			const likeMarkerElement = likeMarkerNodes.item(i) as HTMLElement;
			likeMarkerElement.classList.add(likeMarkerSetUpClass);
			likeMarkerElement.addEventListener('click', listener);
		}
	};
	setUpLikeMarkers();
	const mutationObserver = new MutationObserver(setUpLikeMarkers);
	mutationObserver.observe(document, {
		subtree: true,
		childList: true
	});
}
